const SET_LAST_GRAPHQL = (state, payload) => {
  state.graphQL = payload;
};

export default SET_LAST_GRAPHQL;
